import {NgModule} from '@angular/core';
import {PreloadAllModules, RouterModule, Routes} from '@angular/router';
import {CanActivateGuard} from "../app/service/session/can-activate.guard";

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginPageModule),
  },
  {
    path: 'tabs',
    loadChildren: () =>
      import('./tabs/tabs.module').then((m) => m.TabsPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'programs',
    loadChildren: () =>
      import('./programs/programs.module').then((m) => m.ProgramsPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'registration',
    loadChildren: () =>
      import('./registration/registration.module').then(
        (m) => m.RegistrationPageModule
      ),
  },
  {
    path: 'registration2',
    loadChildren: () =>
      import('./registration2/registration2.module').then(
        (m) => m.Registration2PageModule
      ),
  },
  {
    path: 'registration3',
    loadChildren: () =>
      import('./registration3/registration3.module').then(
        (m) => m.Registration3PageModule
      ),
  },
  {
    path: 'registrationconfirmation',
    loadChildren: () =>
      import('./registrationconfirmation/registrationconfirmation.module').then(
        (m) => m.RegistrationconfirmationPageModule
      ),
  },
  {
    path: 'tutorial',
    loadChildren: () =>
      import('./tutorial/tutorial.module').then((m) => m.TutorialPageModule),
  },
  {
    path: 'recuperationpass',
    loadChildren: () =>
      import('./recuperationpass/recuperationpass.module').then(
        (m) => m.RecuperationpassPageModule
      ),
  },
  {
    path: 'confirmrecuperationpass',
    loadChildren: () =>
      import('./confirmrecuperationpass/confirmrecuperationpass.module').then(
        (m) => m.ConfirmrecuperationpassPageModule
      ),
  },
  {
    path: 'welcome',
    loadChildren: () =>
      import('./welcome/welcome.module').then((m) => m.WelcomePageModule),
  },
  {
    path: 'changepassword',
    loadChildren: () =>
      import('./changepassword/changepassword.module').then(
        (m) => m.ChangePasswordPageModule
      ),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'signaturit',
    loadChildren: () =>
      import('./signaturit/signaturit.module').then(
        (m) => m.SignaturitPageModule
      ),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'accessionbulletin',
    loadChildren: () =>
      import('./accessionbulletin/accessionbulletin.module').then(
        (m) => m.AccessionbulletinPageModule
      ),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'balance',
    loadChildren: () => import('./balance/balance.module').then(m => m.BalancePageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'program-detail',
    loadChildren: () => import('./program-detail/program-detail.module').then(m => m.ProgramDetailPageModule)
  },
  {
    path: 'favourites-partners',
    loadChildren: () => import('./favourites-partners/favourites-partners.module').then(m => m.FavouritesPartnersPageModule)
  },
  {
    path: 'error',
    loadChildren: () => import('./not-found/not-found.module').then(m => m.NotFoundPageModule)
  },
  {
    path: 'claims',
    loadChildren: () => import('./claims/claims.module').then(m => m.ClaimsPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'claim-detail',
    loadChildren: () => import('./claim-detail/claim-detail.module').then(m => m.ClaimDetailPageModule),
    canActivate: [CanActivateGuard]
  }, {
    path: 'claim-new',
    loadChildren: () => import('./claim-new/claim-new.module').then(m => m.ClaimNewPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'documentation',
    loadChildren: () => import('./documentation/documentation.module').then(m => m.DocumentationPageModule),
    canActivate: [CanActivateGuard]
  },
  {
    path: 'contribution-shop',
    loadChildren: () => import('./contribution-shop/contribution-shop.module').then(m => m.ContributionShopPageModule)
  },
  {
    path: 'qr-scanner',
    loadChildren: () => import('./qr-scanner/qr-scanner.module').then(m => m.QrScannerPageModule)
  },
  {
    path: 'my-data',
    loadChildren: () => import('./my-data/my-data.module').then(m => m.MyDataPageModule)
  },
  {
    path: 'configuration',
    loadChildren: () => import('./configuration/configuration.module').then(m => m.ConfigurationPageModule)
  },
  {
    path: 'legal-notices',
    loadChildren: () => import('./legal-notices/legal-notices.module').then(m => m.LegalNoticesPageModule)
  },
  {
    path: '**',
    redirectTo: '/error'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      onSameUrlNavigation: 'reload',
      useHash: true
    }),
  ],
  exports: [RouterModule],
})

export class AppRoutingModule {
}
